<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>
        <v-card-text>
            <div 
                v-if="text != null"
                v-html="text"
            >
            </div>

            <v-text-field
                :label="label"
                v-model="value"
                autofocus
                 @keydown.enter="$event.preventDefault(); onAction(actions[actions.length-1]);"
                 v-if="!textarea"
                 autocomplete="off"
            />

            <v-textarea
                :label="label"
                v-model="value"
                autofocus
                v-else
                auto-grow
            />

            <m-edit-select-objects
                v-if="select_object_type != null"
                :label="label"
                :type="select_object_type"
                v-model="value"
            />

        </v-card-text>
        
        <v-card-actions>
        <v-btn
            v-if="unset_label != null"
            text
            @click="onClickUnset()"
        >
        {{unset_label}}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
            v-for="(action, index) in actions"
            :key="index"
            :color="action_color(index)"
            :disabled="disabled(index)"
            text
            @click="onAction(action)"
        >
        {{action.text}}
        </v-btn>
    </v-card-actions>

    </v-card>

</v-dialog>
</template>

<script>
const Validate = require('@/js/validate.js');
var Preconditions = require('@/js/Preconditions.js'); 

export default {

    data() {
        return {
            dialog: false,
            
            title: '',
            text: '',
            label: null,
            value: null,
            after_prompt: null,
            actions: [],
            is_valid: null,
            textarea: false,
            unset_label: null,
            validation_rules: [],
            select_object_type: null,
        }
    },

    created () {
        this.$event_bus.$on('prompt', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('prompt',this.showDialog);
    },

    methods: {

        showDialog(params) 
        {
            this.title = params.title == null ? 'Alert' : params.title;
            this.text = params.text;
            this.label = params.label;
            this.value = params.value;
            this.after_prompt = params.after_prompt;
            this.actions = params.actions;
            this.textarea = params.textarea == true;
            this.unset_label = params.unset_label;
            this.select_object_type = params.select_object_type;

            this.is_valid = params.is_valid;
            if ( this.is_valid == null )
            {
                this.is_valid = (text) => {
                    if ( params.allow_blank )
                        return true;

                    if ( text == null ) return false;
                    return text.trim().length > 0;
                };
            }

            this.dialog = true;
        },

        isValid()
        {
            return this.is_valid(this.value);
        },

        action_color(index)
        {
            if ( index == this.actions.length -1 ) 
                return 'primary darken-1';
            
            return null;
        },

        disabled(index)
        {
            if ( index != this.actions.length -1 ) 
                return false;
            
            return !this.isValid();
        },

        onAction(action) {
            this.dialog = false;

            if ( this.after_prompt != null && action.value != null )
            {
                this.after_prompt(this.value, action.value);
            }
        },

        onClickUnset()
        {
            this.dialog = false;
            this.after_prompt(null);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>